import React from 'react';

import validate from '@vlabs/shared/validators';
import {
  Control, Margin, Grid, GridRow, GridCol,
} from '@vlabs/uikit';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './CreateHandlerForm.module.sass';

interface SaveIdentifiedFormProps {
  listOptions?: {
    label: string;
    value: string;
  }[];
  onSubmit: (values: unknown) => void;
}
function SaveIdentifiedForm({
  listOptions = [],
  onSubmit,
}: SaveIdentifiedFormProps): React.JSX.Element {
  const { t } = useTranslation();
  const {
    register, control, handleSubmit, formState: { errors },
  } = useForm();

  return (
    <form
      data-testid="modal.saveIdentified"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid>
        <GridRow>
          <GridCol>
            <Margin display="block">
              <span className={st.Description}>
                {t('handlers:сценарий "Сохранение в базе данных идентифицированных в списке лиц" позволяет обнаружить все лица на кадре, проверить Liveness, сравнить обнаруженные лица со всеми лицами в указанном списке и, в случае успешного сравнения, сохранить лицо в заданный список.')}
              </span>
            </Margin>
            <Margin display="block">
              <div className="Body-2">
                {t('handlers:форма.наименование сценария')}
              </div>
              <Control.Input
                {...register('description', {
                  maxLength: validate.maxLength(128),
                  required: validate.required(),
                })}
                errors={errors}
              />
            </Margin>
            <Margin display="block">
              <div className="Body-2">
                {t('handlers:список для сравнения')}
              </div>
              <Control.Select
                control={control}
                errors={errors}
                id="fromListId"
                name="fromListId"
                options={listOptions}
                rules={{ required: validate.required() }}
              />
            </Margin>
            <Margin display="block">
              <div className="Body-2">
                {t('handlers:список для сохранения')}
              </div>
              <Control.Select
                control={control}
                errors={errors}
                id="toListId"
                name="toListId"
                options={listOptions}
                rules={{ required: validate.required() }}
              />
            </Margin>
          </GridCol>
        </GridRow>
      </Grid>
      <Margin display="block">
        <Control.Button
          fullWidth
          type="submit"
        >
          {t('handlers:создать')}
        </Control.Button>
      </Margin>
    </form>
  );
}

export default SaveIdentifiedForm;
